'use strict';
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$0024 from "./app.data.-User-Details$package$-User-Middle-Name$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserDetails$package$UserMiddleNameForm$() {
  this.aGC = null;
  this.aGN = null;
  this.aGF = null;
  this.aGG = false;
  this.aGL = null;
  this.aGM = false;
  this.aGD = null;
  this.aGE = false;
  this.aGJ = null;
  this.aGK = false;
  this.aGH = null;
  this.aGI = false;
  $n_Lapp_data_UserDetails$package$UserMiddleNameForm$ = this;
  this.aGC = $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$0024.$m_Lapp_data_UserDetails$package$UserMiddleName$();
  this.aGN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$0024.$m_Lapp_data_UserDetails$package$UserMiddleName$());
}
export { $c_Lapp_data_UserDetails$package$UserMiddleNameForm$ as $c_Lapp_data_UserDetails$package$UserMiddleNameForm$ };
$p = $c_Lapp_data_UserDetails$package$UserMiddleNameForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_UserDetails$package$UserMiddleNameForm$;
/** @constructor */
function $h_Lapp_data_UserDetails$package$UserMiddleNameForm$() {
}
export { $h_Lapp_data_UserDetails$package$UserMiddleNameForm$ as $h_Lapp_data_UserDetails$package$UserMiddleNameForm$ };
$h_Lapp_data_UserDetails$package$UserMiddleNameForm$.prototype = $p;
$p.eR = (function() {
  return this.aGC;
});
$p.eO = (function() {
  return this.aGN;
});
$p.b9 = (function() {
  if ((!this.aGG)) {
    this.aGF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aGG = true;
  }
  return this.aGF;
});
$p.b3 = (function() {
  if ((!this.aGM)) {
    this.aGL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aGM = true;
  }
  return this.aGL;
});
$p.aG = (function() {
  if ((!this.aGE)) {
    this.aGD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aGE = true;
  }
  return this.aGD;
});
$p.az = (function() {
  if ((!this.aGK)) {
    this.aGJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aGK = true;
  }
  return this.aGJ;
});
$p.aY = (function() {
  if ((!this.aGI)) {
    this.aGH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aGI = true;
  }
  return this.aGH;
});
var $d_Lapp_data_UserDetails$package$UserMiddleNameForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserDetails$package$UserMiddleNameForm$, "app.data.UserDetails$package$UserMiddleNameForm$", ({
  Fh: 1,
  N: 1
}));
export { $d_Lapp_data_UserDetails$package$UserMiddleNameForm$ as $d_Lapp_data_UserDetails$package$UserMiddleNameForm$ };
var $n_Lapp_data_UserDetails$package$UserMiddleNameForm$;
function $m_Lapp_data_UserDetails$package$UserMiddleNameForm$() {
  if ((!$n_Lapp_data_UserDetails$package$UserMiddleNameForm$)) {
    $n_Lapp_data_UserDetails$package$UserMiddleNameForm$ = new $c_Lapp_data_UserDetails$package$UserMiddleNameForm$();
  }
  return $n_Lapp_data_UserDetails$package$UserMiddleNameForm$;
}
export { $m_Lapp_data_UserDetails$package$UserMiddleNameForm$ as $m_Lapp_data_UserDetails$package$UserMiddleNameForm$ };
//# sourceMappingURL=app.data.-User-Details$package$-User-Middle-Name-Form$.js.map
